// extracted by mini-css-extract-plugin
export var image = "_ie-0";